export const resources = {
    forbidenErrorMessage: 'Access to the resource is denied.',
    commonErrorMessage: 'Request failed. Please try again.',
    notFoundErrorMessage: 'Resource not found.'
};